import template from "./vessel-performance-status.html";

function ViewModel(params) {
    var self = this;
    self.performanceStatusItems = params.performanceStatusItems;
}

export default { viewModel: ViewModel, template: template };